export const DATE_PICKER_STYLE = {
	NATIVE: 'native',
	CLASSIC: 'classic',
	STEPPED: 'stepped',
};

export const DATE_PICKER_STYLE_OPTIONS = [
	{ label: 'Native (system)', value: DATE_PICKER_STYLE.NATIVE },
	{ label: 'Classic calendar', value: DATE_PICKER_STYLE.CLASSIC },
	{ label: 'Step by step', value: DATE_PICKER_STYLE.STEPPED },
];
